import { Pipe, PipeTransform } from '@angular/core';
import { DataService } from 'app/services/data.service';

@Pipe({
  name: 'formatComprobante'
})
export class FormatComprobantePipe implements PipeTransform {

  constructor(private dataService: DataService) {}
  /**
   * Formatea el número de comprobante
   * @param value El número de comprobante a formatear
   * @param args Argumentos adicionales (no se utilizan)
   * @returns El número de comprobante formateado o una cadena vacía si el valor es inválido
   */
  transform(value: string | number | null | undefined, ...args: unknown[]): string {
    // Si el valor es null, undefined o no es string ni número, devolver cadena vacía
    if (value === null || value === undefined) {
      return '';
    }
    
    // Convertir a string si es un número
    const stringValue = typeof value === 'number' ? String(value) : value;
    
    // Verificar que sea un string válido
    if (typeof stringValue !== 'string') {
      console.warn('FormatComprobantePipe: valor inválido, debe ser string o número');
      return '';
    }
    
    return this.dataService.formatearNumeroComprobante(stringValue);
  }
}
